import { render } from "./OrderTrackingHeader.vue?vue&type=template&id=13a05ce0&scoped=true"
import script from "./OrderTrackingHeader.vue?vue&type=script&lang=js"
export * from "./OrderTrackingHeader.vue?vue&type=script&lang=js"

import "./OrderTrackingHeader.vue?vue&type=style&index=0&id=13a05ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a05ce0"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
